import { render, staticRenderFns } from "./ShadowReading.vue?vue&type=template&id=79f04f54&"
import script from "./ShadowReading.vue?vue&type=script&lang=js&"
export * from "./ShadowReading.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports